export const selectAnnotationsHidden = (state) => state.annotationsHidden;

export const selectTempAnnotations = (state) => state.tempAnnotations;

export const selectCommentBoxCancelled = (state) => state.commentBoxCancelled;

// TODO
